<template>
  <div class="tw:relative">
    <BaseCard
      v-if="isMenuOpen"
      v-click-outside="onClickaway"
      no-padding
      class="tw:absolute tw:z-10 tw:flex tw:min-w-[300px] tw:w-[calc(100%-20px)] tw:xs:min-w-[340px] tw:mx-[10px] menu-card-mobile tw:rounded-xl tw:right-0"
    >
      <div class="tw:p-[15px] tw:w-full">
        <ul class="tw:mb-2">
          <li
            class="tw:items-center tw:text-sm tw:justify-between tw:py-1.5 tw:px-3 tw:hover:cursor-pointer tw:hover:bg-gray-200 tw:active:bg-gray-200 tw:rounded tw:font-bold tw:mb-2 tw:w-full tw:flex"
          >
            <BaseLink :to="{ name: 'getstarted' }" class="tw:w-full tw:flex tw:items-center tw:justify-between">
              <span>{{ $t('navigation.home') }}</span>
            </BaseLink>
          </li>
          <li
            class="tw:items-center tw:text-sm tw:justify-between tw:py-1.5 tw:px-3 tw:hover:cursor-pointer tw:hover:bg-gray-200 tw:active:bg-gray-200 tw:rounded tw:font-bold tw:mb-2 tw:w-full tw:flex"
            :class="{ selected: selectedTab === 'products' }"
            @click="toggleTab('products')"
            @keydown.enter="toggleTab('products')"
          >
            {{ $t('navigation_menu_our_solutions') }}
            <ChevronRight
              class="tw:hover:fill-blue-800 arrow-dropdown tw:fill-gray-800 tw:w-6 tw:h-[18px]"
            />
          </li>
          <ul v-if="selectedTab === 'products'" class="tw:ml-6 tw:mb-2">
            <li v-for="item in productLinks" :key="item.id">
              <a
                class="tw:hover:no-underline tw:w-full tw:py-1 tw:px-1 tw:hover:text-gray-800 tw:flex tw:items-center tw:justify-between tw:hover:bg-blue-100 tw:text-sm tw:hover:rounded"
                :href="item.newPage ? getSupportCenterUrl(locale.value, item.url) : item.url"
                :target="item.newPage ? '_blank' : ''"
              >
                <span v-html="$t(item.label)" />
              </a>
            </li>
          </ul>
          <li
            class="tw:font-bold tw:mb-2 tw:items-center tw:text-sm tw:justify-between tw:py-1.5 tw:px-3 tw:hover:cursor-pointer tw:hover:cursor-pointer tw:hover:bg-gray-200 tw:rounded tw:w-full tw:flex"
            :class="{ selected: selectedTab === 'support' }"
            @click="toggleTab('support')"
            @keydown.enter="toggleTab('support')"
          >
            {{ $t('navigation_menu_support_center') }}
            <ChevronRight
              class="tw:hover:fill-blue-800 arrow-dropdown tw:fill-gray-800 tw:w-6 tw:h-[18px]"
            />
          </li>
          <ul v-if="selectedTab === 'support'" class="tw:ml-6 tw:mb-2">
            <li v-for="item in supportLinks" :key="item.id">
              <a
                class="tw:hover:no-underline tw:w-full tw:py-1 tw:px-1 tw:hover:text-gray-800 tw:flex tw:items-center tw:hover:bg-blue-100 tw:text-sm tw:hover:rounded"
                :href="item.isUrl ? item.url : getSalesforceUrl(item.url)"
                :target="item.newPage ? '_blank' : ''"
              >
                <span class="tw:mr-2" v-html="$t(item.label)" />
                <External v-if="item.withIcon" />
              </a>
            </li>
          </ul>
        </ul>

        <MainButton
          size="big"
          no-padding
          class="tw:flex tw:w-full tw:text-center tw:justify-center"
          @click="() => onAuthorize('signup')"
          @keydown.enter="() => onAuthorize('signup')"
        >
          {{ $t('tbs_mp_log_in_cta') }}
        </MainButton>
      </div>
    </BaseCard>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import { getSupportCenterUrl, getContactUrl } from '@/utils/Utility.ts'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import appAnalytics from '@/utils/tracking'

import External from '@/components/icons/External.svg?component'
import BaseCard from '@/components/dashboard/BaseCard.vue'
import ChevronRight from '@/components/icons/ChevronRight.svg?component'
import MainButton from '@/components/base/buttons/MainButton.vue'
import BaseLink from '@/components/BaseLink.vue'
import { useSessionValues } from '@/composables/useSessionValues'

defineProps({
  supportLinks: Array,
  productLinks: Array,
  isMenuOpen: Boolean,
})
const emit = defineEmits(['onClickaway'])
const onClickaway = () => emit('onClickaway')
const selectedTab = ref('')
const store = useStore()
const route = useRoute()
const { language } = useSessionValues()

const toggleTab = name => {
  if (name === selectedTab.value) {
    selectedTab.value = ''
  } else {
    selectedTab.value = name
  }
}

const getSalesforceUrl = type => {
  if (type === 'contactUs') {
    return getContactUrl(language.value)
  }
  if (type === 'supportCentre') {
    return getSupportCenterUrl(language.value)
  }
}
const authorize = authData => store.dispatch('session/authorize', authData)
const onAuthorize = async (type = 'login') => {
  appAnalytics.track(type === 'login' ? appAnalytics.events.BUTTON_CLICKED : appAnalytics.events.BUTTON_CLICKED, {
    button: type,
    property_id: null,
  })
  await authorize({
    type,
    stateParams: {
      redirectFrom: route.query.redirectFrom,
    },
    locale: language.value,
  })
}
</script>
<style scoped>
.arrow-dropdown {
  top: 1px;
  bottom: 0;
  height: 100%;
  right: 0;
  pointer-events: none;
  transform: translateY(0%) rotate(90deg);
}
.selected .arrow-dropdown {
  transform: translateY(0%) rotate(-90deg);
  fill: var(--tw-color-blue-700);
}
.selected {
  background-color: var(--tw-color-white);
  margin-bottom: 0;
}
.menu-card-mobile {
  top: 10px;
}
</style>
